import React, { useState, useEffect } from 'react';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import { bodyStyle, fixHeader } from './CallReport.module.css';
import FilterListIcon from '@material-ui/icons/FilterList';
import CustomMaterialPagination from '../../components/Table/customPagination';
import PopupFilter from '../../common/components/PopupFilter/PopupFilter';
import RMList from '../../common/components/PopupFilter/FilterComponents/RmList';
import DateFilter from '../../common/components/PopupFilter/FilterComponents/DateFilter';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { getReport } from '../../common/constants/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import NewSpinner from '../../common/components/NewSpinner/NewSpinner';
import moment from 'moment';
import {
  setApplicantionInfo,
  getApplicantionInfo
} from '../../common/utils/applicantionInfo';
import { navigate } from 'gatsby';
import { getFiltersInfo, setFiltersInfo } from '../../common/utils/FiltersInfo';

const CallReport = () => {
  const [rowsPerPage, setRowsPerPage] = useState('50');
  const [rows, setRows] = useState('10');
  const [page, setPage] = useState('0');
  const [show, setShow] = useState(false);
  const [htmlFormatSelectedFields, setHtmlSelectedFileds] = useState({});
  const [callData, setCallData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstLoading, setIsFirstLoading] = useState(true);
  const [fromDate, setFromDate] = useState(
    getFiltersInfo()?.callReport?.fromDate || moment().format('YYYY-MM-DD')
  );
  const [toDate, setToDate] = useState(
    getFiltersInfo()?.callReport?.endDate || moment().format('YYYY-MM-DD')
  );

  const tableHeader = `font-khand font-medium  text-sm  text-black-500 px-4  py-5 ${fixHeader}`;

  const tableBody =
    'font-roboto font-normal  text-xs  text-black-850 px-4  py-5';

  const handlePageChange = pageNumber => {
    setPage(pageNumber - 1);
  };
  const handlePerRowsChange = (rows, pageNumber) => {
    setRows(rows);
    setPage(0);
  };

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Date',
      name: 'date',
      component: DateFilter
    }
  ];
  const appledFilters = filters => {
    setFromDate(filters?.dateFilter?.startDate);
    setToDate(filters?.dateFilter?.endDate);
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      callReport: {
        fromDate: filters?.dateFilter?.startDate,
        endDate: filters?.dateFilter?.endDate
      }
    });
  };

  const getCallReport = () => {
    setIsLoading(true);
    getReport({
      report: 'call-report',
      number: page,
      size: rows,
      startDate: moment(fromDate).format('YYYY-MM-DD'),
      endDate: moment(toDate).format('YYYY-MM-DD')
    })
      .then(res => {
        setIsFirstLoading(false);
        setIsLoading(false);
        setCallData(res?._embedded?.employeeCallReportDtoList || []);
        setRowsPerPage(res?.page);
      })

      .catch(error => {
        setIsFirstLoading(false);
        setIsLoading(false);
        setCallData([]);
      });
  };
  useEffect(() => {
    getCallReport();
    return () => {
      setIsFirstLoading(true);
    };
  }, []);

  useEffect(() => {
    if (!isFirstLoading) getCallReport();
  }, [page, rows, fromDate, toDate]);

  const handleEventClick = (data, callType) => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      callLogs: {
        callMade: {
          startDate: fromDate,
          toDate: toDate
        },

        callType: {
          [callType]: {
            name: callType,
            key: callType,
            status: callType && true
          }
        },
        rm: {
          [data?.rmId]: {
            fullName: `${data?.rmName?.firstName || ''} ${data?.rmName
              ?.middleName || ''} ${data?.rmName?.lastName || ''}`,
            status: true
          }
        }
      }
    });

    navigate('/app/report/call/logs');
  };
  return (
    <React.Fragment>
      <Helmet title={`Call Report | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar /> 
          <div className="w-full max-screen">
            <div className="w-full flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">
                    Performance Report
                  </span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-green-800">Call Report</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="w-full px-4 mt-6">
              <div className="w-full bg-white py-4 px-5 rounded-xl shadow">
                <div
                  className="cursor-pointer py-1"
                  style={{ width: '150px' }}
                  onClick={() => setShow(true)}
                >
                  <div className="border border-grey-2235 rounded flex py-2 px-4">
                    <p className="text-grey-2236 font-roboto font-normal text-sm">
                      Filter
                    </p>
                    <div className="table ml-auto ">
                      <FilterListIcon style={{ color: '#8a939e' }} />
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  {Object.keys(htmlFormatSelectedFields || {}).map(
                    each => htmlFormatSelectedFields[each]
                  )}
                </div>
                <div
                  className="w-full overflow-auto"
                  style={{ maxHeight: '65vh' }}
                >
                  <table className="w-full ">
                    <thead>
                      <tr className="py-4">
                        <th className={`${tableHeader} text-center`}>SL No</th>
                        <th className={`${tableHeader} text-center `}>
                          RM Name
                        </th>
                        <th className={`${tableHeader} text-right`}>
                          Total Calls made
                        </th>
                        <th className={`${tableHeader} text-right`}>
                          Total Connected Calls
                        </th>
                        <th className={`${tableHeader} text-right`}>
                          Total Call Duration
                        </th>
                        <th className={`${tableHeader} text-right`}>
                          Avg Call Duration
                        </th>
                        <th className={`${tableHeader} text-right`}>
                          Unique Calls
                        </th>
                      </tr>
                    </thead>
                    <tbody className="w-full">
                      {isLoading && (
                        <tr className="w-ful">
                          <td colSpan="7">
                            <div className="table mx-auto text-center mt-10">
                              <NewSpinner />
                            </div>
                          </td>
                        </tr>
                      )}
                      {!isLoading && callData?.length == 0 && (
                        <tr className="w-ful bg-grey-1004">
                          <td colSpan="7" className="py-5">
                            <div className="table mx-auto text-center text-center ">
                              No call records found!
                            </div>
                          </td>
                        </tr>
                      )}
                      {!isLoading &&
                        callData?.map((each, index) => (
                          <tr className={`w-full ${bodyStyle}`}>
                            <td className={`${tableBody} text-center`}>
                              {rowsPerPage?.number * rowsPerPage?.size +
                                index +
                                1}
                            </td>
                            <td className={`${tableBody} text-center`}>
                              {each?.rmName?.firstName || ''}
                              {` ${each?.rmName?.middleName || ' '}`}
                              {` ${each?.rmName?.lastName || ' '}`}
                            </td>
                            <td className={`${tableBody} text-right `}>
                              <span
                                className="cursor-pointer text-blue-700 font-medium"
                                onClick={() => handleEventClick(each, '')}
                              >
                                {each?.totalCalls}
                              </span>
                            </td>
                            <td className={`${tableBody} text-right`}>
                              <span
                                className="cursor-pointer text-blue-700 font-medium"
                                onClick={() =>
                                  handleEventClick(each, 'completed')
                                }
                              >
                                {each?.totalConnectedCalls}
                              </span>
                            </td>
                            <td className={`${tableBody} text-right`}>
                              {each?.totalDurationTime}
                            </td>
                            <td className={`${tableBody} text-right`}>
                              {each?.avgDurationTime}
                            </td>
                            <td className={`${tableBody} text-right`}>
                              {each?.totalUniqueCalls}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <CustomMaterialPagination
                  handlePageChange={handlePageChange}
                  handlePerRowsChange={handlePerRowsChange}
                  setRowsPerPage={setRowsPerPage}
                  setPage={setPage}
                  page={page}
                  pageInfo={rowsPerPage}
                  setRows={setRows}
                  Rows={rows}
                />
              </div>
            </div>
          </div>
        </div>
        <PopupFilter
          show={show}
          setShow={setShow}
          dataList={dataList}
          handleApply={appledFilters}
          handleToastBlock={e => setHtmlSelectedFileds(e)}
          masterFiltersData={{
            dateFilter: {
              startDate: getFiltersInfo()?.callReport?.fromDate,
              endDate: getFiltersInfo()?.callReport?.endDate
            }
          }}
        />
      </div>
    </React.Fragment>
  );
};
export default CallReport;
